import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateCargoDescriptionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateCargoDescriptionInput;
}>;

export type UpdateCargoDescriptionMutationResult = { __typename?: 'Mutation' } & {
  updateCargoDescription: { __typename?: 'UpdateCargoDescriptionPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateCargoDescriptionDocument = /*#__PURE__*/ gql`
  mutation updateCargoDescription($input: UpdateCargoDescriptionInput!) {
    updateCargoDescription(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateCargoDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateCargoDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCargoDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCargoDescriptionMutation, { data, loading, error }] = useUpdateCargoDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCargoDescriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCargoDescriptionMutationResult, UpdateCargoDescriptionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateCargoDescriptionMutationResult, UpdateCargoDescriptionMutationVariables>(
    UpdateCargoDescriptionDocument,
    options
  );
}
export type UpdateCargoDescriptionMutationHookResult = ReturnType<typeof useUpdateCargoDescriptionMutation>;
